import React from "react";
import { useGetProfileQuery } from "../../store/api/authApi";
import TenantPortal from "../tenant-portal";
import Loader from "../../components/ui/Loader";

const TenantDashboard: React.FC = () => {
	const { data: user, isLoading } = useGetProfileQuery();

	if (isLoading) {
		return <Loader size="md" showText text="Loading dashboard..." className="h-64" />;
	}

	return (
		<div className="w-full">
			<TenantPortal />
		</div>
	);
};

export default TenantDashboard;
